import { NgModule } from '@angular/core'
import type { Routes } from '@angular/router'
import { RouterModule } from '@angular/router'

import { redirectLoginGuard } from '../../guards/redirect-login.guard'
import { hasStateParameterGuard } from '../auth/guards/has-state-parameter.guard'
import { ProductsCheckoutComponent } from './pages/products-checkout.component'
import { ProductsPaymentComponent } from './pages/products-payment.component'
import { ProductsComponent } from './pages/products.component'

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', component: ProductsComponent },
      {
        path: 'checkout',
        component: ProductsCheckoutComponent,
        canActivate: [hasStateParameterGuard(['products'], ['products'])],
      },
      {
        path: 'payment',
        component: ProductsPaymentComponent,
        // TODO: consider if this guard is necessary or not and if so refactor
        //canActivate: [hasStateParameterGuard(['recurringInvoiceId'], ['products'])],
      },
    ],
    canActivate: [redirectLoginGuard],
  },
  { path: '**', redirectTo: '' },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductRoutingModule {}
